<template>
  <layout>
    <v-card elevation="4" class="pa-4 ma-5 card">
      <v-card-title class="justify-center">
        <h1 class="max">{{i18n('Resumo da Transação')}}</h1>
      </v-card-title>

      <v-card-text>
        <span class="span-title">{{i18n("Status")}}:</span>
        <span class="span-text">{{transactionStatus}}</span>
      </v-card-text>

      <v-card-text>
        <span class="span-title">{{i18n("Moeda")}}:</span>
        <span class="span-text">{{this.transaction.currency}}</span>
      </v-card-text>

      <v-card-text>
        <span class="span-title">{{i18n("Valor")}}:</span>
        <span class="span-text">{{this.transaction.value}}</span>
      </v-card-text>

      <v-card-text>
        <span class="span-title">{{i18n("De")}}:</span>
        <span class="span-text">{{this.transaction.subject != null ? this.transaction.subject.social_name : null}}</span>
      </v-card-text>

      <v-card-text>
        <span class="span-title">{{i18n("Para")}}:</span>
        <span class="span-text">{{this.transaction.to_bank_account != null ? this.transaction.to_bank_account.owner_company.social_name : null}}</span>
      </v-card-text>
    </v-card>
  </layout>
</template>

<script>
import BaseLayout from "./layouts/BaseLayout"
import Title from "./components/Title"

export default {
  name: 'ConfirmThreeDSTransaction',
  components: { layout: BaseLayout, 'page-title': Title },
  data: () => {
    return {
      transaction: {}
    }
  },
  mounted () {
    this.confirmThreeDSTransaction()
  },
  computed: {
    transactionStatus() {
      if (!this.transaction.status) return ''
      if (['identified', 'exchanged', 'wired'].includes(this.transaction.status)) return this.i18n("Sucesso")
      return this.i18n("Falha")
    },
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    confirmThreeDSTransaction() {
      if (!this.$route.query.id) return false

      let payload = {
        "payment_id": this.$route.query.id
      };

      let successCallback = (response) => {
        console.log("Success Callback - Body - Data")
        console.log(response.body.data)
        if (response.body.data.id) {
          this.transaction = response.body.data
        }
      }

      let errorCallback = (response) => {
        console.log("Error Callback")
        console.log(response)
      }

      let token = this.$cookies.get('api_token')
      this.$http
        .post(this.$root.urls.openpay_confirm_threeds_transaction, payload, { headers: { Authorization: `Bearer ${token}` }})
        .then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  body {
    background-color: #092d49 !important;
    color: aliceblue;
  }

  .card {
    background-color: aliceblue !important;
    font-family: 'Paralucent';
  }

  .span-title {
    font-size: 1.5rem;
    color: #0C2E4A;
    margin-right: 12px;
  }

  .span-text {
    font-size: 1.5rem;
    color: #44517B;
  }
</style>



// WEBPACK FOOTER //
// src/ConfirmThreeDSTransaction.vue